/**
 * Cockpit API - Territory
 *
 * Contact: info@formunauts.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { LicenceStatus } from '../model/licence-status.api-model';
// @ts-ignore
import { TerritoryDetailResponse } from '../model/territory-detail-response.api-model';
// @ts-ignore
import { TerritoryMinimalResponse } from '../model/territory-minimal-response.api-model';
// @ts-ignore
import { TerritoryPageResponse } from '../model/territory-page-response.api-model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { FmntsCockpitApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface TerritoryGetRequestParams {
  /** The id of the territory to get. */
  id: string;
}

export interface TerritoryListRequestParams {
  /** Narrows down result to territories of the top level region, identified by iso code.  */
  region_id: string;
  /** Narrows down result to territories of the given level. */
  level_id: number;
  /** Filters the result by territories whose name, parent’s name, licence\&#39;s document number or licence\&#39;s organization name contain the term.  */
  search?: string;
  /** Filters the result by territories whose licences are related to one of those organization ids. */
  licences__organization_id?: ReadonlyArray<number>;
  /** Narrows down result to licences that have one of the given statuses  */
  licences__status?: ReadonlyArray<LicenceStatus>;
  /** Filters the result by territories with licences that would be active after &#x60;licenced_after&#x60; and before &#x60;licenced_before&#x60;. Must be used in conjuction with &#x60;licenced_before&#x60;.  */
  licenced_after?: string;
  /** Filters the result by territories with licences that would be active after &#x60;licenced_after&#x60; and before &#x60;licenced_before&#x60;. Must be used in conjuction with &#x60;licence_after&#x60;.  */
  licenced_before?: string;
  /** A page number within the paginated result set.  */
  page?: number;
  /** Number of results to return per page.  */
  page_size?: number;
}

export interface TerritorySuggestRequestParams {
  /** Filter the results where the query string is a substring of &#x60;name&#x60;. The matching is case insensitive.  */
  name?: string;
  /** Filter the results by iso code of &#x60;region&#x60;.  */
  region?: string;
  /** Filter the results by &#x60;level&#x60;.  */
  level?: number;
  /** Filter the results to only include direct children of &#x60;parent&#x60;.  */
  parent?: string;
  /** Filter the results by &#x60;licence_required&#x60;. */
  licence_required?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TerritoriesApi extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: FmntsCockpitApiConfiguration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Get details for a territory by &#x60;id&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public territoryGet(
    requestParameters: TerritoryGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<TerritoryDetailResponse>;
  public territoryGet(
    requestParameters: TerritoryGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<TerritoryDetailResponse>>;
  public territoryGet(
    requestParameters: TerritoryGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<TerritoryDetailResponse>>;
  public territoryGet(
    requestParameters: TerritoryGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling territoryGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/territories/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/`;
    return this.httpClient.request<TerritoryDetailResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get all territories of a given level for a specific top level region.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public territoryList(
    requestParameters: TerritoryListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<TerritoryPageResponse>;
  public territoryList(
    requestParameters: TerritoryListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<TerritoryPageResponse>>;
  public territoryList(
    requestParameters: TerritoryListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<TerritoryPageResponse>>;
  public territoryList(
    requestParameters: TerritoryListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const region_id = requestParameters?.region_id;
    if (region_id === null || region_id === undefined) {
      throw new Error(
        'Required parameter region_id was null or undefined when calling territoryList.',
      );
    }
    const level_id = requestParameters?.level_id;
    if (level_id === null || level_id === undefined) {
      throw new Error(
        'Required parameter level_id was null or undefined when calling territoryList.',
      );
    }
    const search = requestParameters?.search;
    const licences__organization_id =
      requestParameters?.licences__organization_id;
    const licences__status = requestParameters?.licences__status;
    const licenced_after = requestParameters?.licenced_after;
    const licenced_before = requestParameters?.licenced_before;
    const page = requestParameters?.page;
    const page_size = requestParameters?.page_size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>search,
      'search',
    );
    if (licences__organization_id) {
      licences__organization_id.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'licences__organization_id',
        );
      });
    }
    if (licences__status) {
      licences__status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'licences__status',
        );
      });
    }
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>licenced_after,
      'licenced_after',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>licenced_before,
      'licenced_before',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>page,
      'page',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>page_size,
      'page_size',
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/territories/${this.configuration.encodeParam({ name: 'region_id', value: region_id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/${this.configuration.encodeParam({ name: 'level_id', value: level_id, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: undefined })}/`;
    return this.httpClient.request<TerritoryPageResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Returns a non-paginated response of territories searchable by name substring, level, top level region and parent territory. The results are ordered alphabetically by &#x60;name&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public territorySuggest(
    requestParameters?: TerritorySuggestRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<ReadonlyArray<TerritoryMinimalResponse>>;
  public territorySuggest(
    requestParameters?: TerritorySuggestRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<ReadonlyArray<TerritoryMinimalResponse>>>;
  public territorySuggest(
    requestParameters?: TerritorySuggestRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<ReadonlyArray<TerritoryMinimalResponse>>>;
  public territorySuggest(
    requestParameters?: TerritorySuggestRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const name = requestParameters?.name;
    const region = requestParameters?.region;
    const level = requestParameters?.level;
    const parent = requestParameters?.parent;
    const licence_required = requestParameters?.licence_required;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>name,
      'name',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>region,
      'region',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>level,
      'level',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>parent,
      'parent',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>licence_required,
      'licence_required',
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/territories/suggestions/`;
    return this.httpClient.request<ReadonlyArray<TerritoryMinimalResponse>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }
}
